import moment from 'moment';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Table,
  Typography,
} from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { Invoice, invoiceStatusKorean } from '../../modules/invoices';
import { useState } from 'react';
import { priceToString } from '../../util/utils';
import { getSubInvoiceList } from '../../api/constlink';

interface SubInvoiceCreateModalProps {
  visible: boolean;
  enterpriseId: string;
  invoice: Invoice;
  onCreate: (idList: number[]) => void;
  onCancel: () => void;
}

function SubInvoiceCreateModal({
  visible,
  enterpriseId,
  invoice,
  onCreate,
  onCancel,
}: SubInvoiceCreateModalProps) {
  const [selectedValues, setSelectedValues] = useState<any>([]);
  const [subInvoices, setSubInvoices] = useState<Invoice[]>();
  const [form] = Form.useForm();
  const dateFormat = 'YYYY-MM-DD';
  const { Text } = Typography;

  const columns: ColumnsType<Invoice> = [
    {
      title: '회사명',
      dataIndex: ['vendor', 'application', 'general', 'name'],
      defaultSortOrder: 'ascend',
      width: '15%',
      render: (text: any, record: any) => <>{text}</>,
    },
    {
      title: '카테고리',
      dataIndex: 'category',
      width: '10%',
    },
    {
      title: '청구일',
      dataIndex: 'billingDate',
      width: '10%',
      render: (text: any, record: any, index: any) =>
        record.usedDate === null
          ? ''
          : moment(record.billingDate).format('YYYY-MM-DD'),
    },
    {
      title: '제출자',
      dataIndex: ['submittedBy', 'name'],
      width: '10%',
      render: (text: any, record: any) => <>{text === null ? '' : text}</>,
    },
    {
      title: '상태',
      dataIndex: 'status',
      width: '10%',
      render: (text: any, record: Invoice) =>
        invoiceStatusKorean[record.status],
    },
    {
      title: '공사명',
      dataIndex: ['project', 'name'],
      width: '20%',
      render: (text: any, record: any) => (
        <>
          {text === null ? (
            ''
          ) : (
            <Text ellipsis={true} style={{ width: '200px' }}>
              {text}
            </Text>
          )}
        </>
      ),
    },
    {
      title: '금액(원)',
      dataIndex: 'price',
      sorter: (a: Invoice, b: Invoice) => a.price - b.price,
      width: '15%',
      align: 'right',
      render: (value: any, record: any, index: any) => priceToString(value),
    },
  ];

  const searchSubInvoiceList = async (formData: any) => {
    const invoiceData = await getSubInvoiceList({
      enterpriseId,
      invoiceId: '' + invoice.id,
      filterData: {
        startDate: moment(formData.startDate).format('YYYY-MM-DD'),
        endDate: moment(formData.endDate).format('YYYY-MM-DD'),
      },
    });
    if (invoiceData.success) {
      setSubInvoices(invoiceData.invoices);
    } else {
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedValues([...selectedRowKeys]);
    },
    selectedRowKeys: selectedValues,
  };

  return (
    <>
      <Modal
        open={visible}
        title="업체검색"
        okText="확인"
        cancelText="취소"
        width={1100}
        onCancel={onCancel}
        onOk={() => {
          onCreate(selectedValues);
        }}
      >
        <Form
          layout="inline"
          form={form}
          onFinish={searchSubInvoiceList}
          initialValues={{}}
        >
          {/* <Row>
            <Col span={11}>
              <Form.Item
                name="startDate"
                label="시작일"
                rules={[
                  {
                    required: true,
                    message: '시작일을 선택해 주세요.',
                  },
                ]}
              >
                <DatePicker format={dateFormat} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row> */}

          <Row>
            <Col>
              <Form.Item
                name="startDate"
                label="시작일"
                rules={[
                  {
                    required: true,
                    message: '시작일을 선택해 주세요.',
                  },
                ]}
              >
                <DatePicker format={dateFormat} style={{ width: '180px' }} />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                name="endDate"
                label="종료일"
                rules={[
                  {
                    required: true,
                    message: '종료일을 선택해 주세요.',
                  },
                ]}
              >
                <DatePicker format={dateFormat} style={{ width: '180px' }} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>
                <Button htmlType="submit" type="primary">
                  검색
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Table
          rowKey="id"
          size="small"
          columns={columns}
          rowSelection={{ ...rowSelection, checkStrictly: false }}
          dataSource={subInvoices}
        />
      </Modal>
    </>
  );
}

export default SubInvoiceCreateModal;
